const stateKeys = ['tariffs', 'tariffDetail']

export const actions = {
  clearSettings() {
    for (let ix = 0; ix < stateKeys.length; ix++) {
      this.$storage.removeUniversal(stateKeys[ix])
    }
  },
  setTariffs(_, tariffs) {
    this.$storage.setUniversal('tariffs', tariffs)
  },
  getTariffs() {
    return this.$storage.getUniversal('tariffs')
  },
  async setTariffDetail({ dispatch }, tariff) {
    if (!tariff) {
      this.$storage.removeUniversal('tariffDetail')
    } else {
      const oldTariff = await dispatch('getTariffDetail')
      this.$storage.setUniversal('tariffDetail', { ...oldTariff, ...tariff })
    }
  },
  getTariffDetail() {
    return this.$storage.getUniversal('tariffDetail')
  },
  async getData({ dispatch }) {
    const data = await this.$apiAaltra.settingsEnergyTariff()
    if (
      !data ||
      (data && data.plans && !data.plans.find((data) => data.start))
    ) {
      return []
    }
    data.list =
      data && data.plans
        ? data.plans.map((data) => {
            return {
              title: data.current
                ? this.app.i18n.t('activeTariff')
                : this.app.i18n.t('plannedTariff'),
              text: `${this.$formatEpochToShortDate(data.start)} - ${
                data.end
                  ? this.$formatEpochToShortDate(data.end)
                  : data.current
                  ? this.app.i18n.t('present')
                  : this.app.i18n.t('undetermined')
              }`,
              route: {
                name: 'energy-settings-tariff-detail',
                query: { tariff: data.current ? 'active' : 'planned' }
              }
            }
          })
        : []

    if (data.errors) return data.errors
    else {
      await dispatch('setTariffs', data.plans || [])
      return data.list
    }
  },
  async getTariffOverview({ dispatch }) {
    const tariffDetail = await dispatch('getTariffDetail')

    const duration =
      !tariffDetail.start && !tariffDetail.end
        ? null
        : [
            {
              text: [
                this.app.i18n.t('startDate'),
                this.$formatEpochToShortDate(tariffDetail.start)
              ]
            },
            {
              text: [
                this.app.i18n.t('endDate'),
                tariffDetail.end
                  ? this.$formatEpochToShortDate(tariffDetail.end)
                  : tariffDetail.current
                  ? this.app.i18n.t('present')
                  : this.app.i18n.t('undetermined')
              ]
            }
          ]

    let variableCost = null
    const rateString = tariffDetail.nightPrice
      ? this.app.i18n.t('nightAndDay')
      : this.app.i18n.t('singleRate')

    if (tariffDetail.dayPrice && !tariffDetail.nightPrice) {
      variableCost = []
      variableCost.push(
        {
          text: [this.app.i18n.t('costRateQuestion'), rateString]
        },
        {
          text: [
            `${this.app.i18n.t('pricePerKwh')}`,
            `${this.app.$formatCurrency(
              tariffDetail.dayPrice
            )} ${this.app.$currency.getCurrencyPerKwh()}`
          ]
        }
      )
    }

    if (
      tariffDetail.dayRateStart !== null &&
      tariffDetail.dayRateEnd !== null &&
      tariffDetail.nightPrice !== null &&
      tariffDetail.dayPrice !== null
    ) {
      variableCost = []
      variableCost.push({
        text: [this.app.i18n.t('costRateQuestion'), rateString]
      })
      variableCost.push({
        text: [
          this.app.i18n.t('dayPrice'),
          `${this.app.$formatCurrency(
            tariffDetail.dayPrice
          )} ${this.app.$currency.getCurrencyPerKwh()}`
        ]
      })

      if (tariffDetail.nightPrice) {
        variableCost.push({
          text: [
            this.app.i18n.t('nightPrice'),
            `${this.app.$formatCurrency(
              tariffDetail.nightPrice
            )} ${this.app.$currency.getCurrencyPerKwh()}`
          ]
        })
        variableCost.push({
          text: [
            this.app.i18n.t('dayRatePeriod'),
            `${this.app.$formatTime(
              tariffDetail.dayRateStart
            )} - ${this.app.$formatTime(tariffDetail.dayRateEnd)}`
          ]
        })
      }
    }

    let fixedCost = null
    if (tariffDetail.fixedCost && tariffDetail.fixedPeriod) {
      fixedCost = []
      const currency = this.app.$currency.get()
      const period = this.app
        .$radioButtonGroup('fixed-costs')
        .find((item) => item.value === tariffDetail.fixedPeriod)

      fixedCost.push({
        text: [this.app.i18n.t('periodicity'), period.text]
      })
      fixedCost.push({
        text: [
          this.app.i18n.t('fixedCost'),
          `${this.app.$formatCurrency(tariffDetail.fixedCost)} ${currency}/${
            period.unit
          }`
        ]
      })
    }

    let solar = null
    if (tariffDetail) {
      solar = []
      solar.push({
        text: [
          this.app.i18n.t('pvInstallationQuestion'),
          tariffDetail.hasSolar ? this.app.i18n.t('yes') : this.app.i18n.t('no')
        ]
      })

      if (tariffDetail.generationPrice) {
        solar.push({
          text: [
            this.app.i18n.t('pvGenerationTariff'),
            `${this.app.$formatCurrency(
              tariffDetail.generationPrice
            )} ${this.app.$currency.getCurrencyPerKwh()}`
          ]
        })
      }
      if (tariffDetail.exportedPrice) {
        solar.push({
          text: [
            this.app.i18n.t('pvExportTariff'),
            `${this.app.$formatCurrency(
              tariffDetail.exportedPrice
            )} ${this.app.$currency.getCurrencyPerKwh()}`
          ]
        })
      }
    }

    const tariffOverview = [
      {
        label: this.app.i18n.t('dateDuration'),
        rows: duration
      },
      {
        label: this.app.i18n.t('costPerKwh'),
        rows: variableCost
      },
      {
        label: this.app.i18n.t('fixedCost'),
        rows: fixedCost
      },
      {
        label: this.app.i18n.t('solarPvInstallation'),
        rows: solar
      }
    ]

    return tariffOverview
  },
  async saveData(_, energyTariffSettings) {
    if (energyTariffSettings.current) {
      delete energyTariffSettings.current
    }
    if (energyTariffSettings.warning) {
      delete energyTariffSettings.warning
    }
    if (energyTariffSettings.error) {
      delete energyTariffSettings.error
    }
    const axios = await this.$apiAaltra.updateSettingsEnergyTariff({
      current: true,
      ...energyTariffSettings
    })
    const axiosErrors = axios?.response?.data?.errors

    let errors = []
    if (axios?.response?.status === 400 && axiosErrors) {
      for (const prop in axiosErrors) {
        if (Object.prototype.hasOwnProperty.call(axiosErrors, prop)) {
          errors = errors.concat(axiosErrors[prop])
        }
      }
    }
    return errors
  }
}
